/** Top-level user profile page — not inside the settings hub. */
export const PROFILE_ROUTE = '/dashboard/profile' as const;

const PRODUCT_ROUTES_ROOT = '/dashboard/products';

/**
 * Katalog bölümü. Ürün eşleştirme bir ayar değil, günlük katalog bakımının
 * parçası: pazaryeri ürünlerini yerel ürün kartlarıyla eşliyor. Bu yüzden
 * ayarlar menüsünde değil, Ürünler sayfasının yanında duruyor.
 */
export const PRODUCT_ROUTES = {
  root: PRODUCT_ROUTES_ROOT,
  matching: `${PRODUCT_ROUTES_ROOT}/matching`,
  new: `${PRODUCT_ROUTES_ROOT}/new`,
  detail: (id: string) => `${PRODUCT_ROUTES_ROOT}/${id}`,
} as const;

/**
 * Fatura bölümü: giden faturalar kök sayfa, gelen faturalar ve seriler onun
 * altındaki sekmeler. Sidebar tek bir "Faturalar" girdisi taşır; alt sayfalara
 * sayfa içindeki sekme şeridinden gidilir.
 */
export const INVOICE_ROUTES = {
  root: '/dashboard/invoices',
  inbound: '/dashboard/invoices/inbound',
  series: '/dashboard/invoices/series',
} as const;

/** Geriye dönük ad — fatura serileri artık Faturalar bölümünün bir sekmesi. */
export const INVOICE_SERIES_ROUTE = INVOICE_ROUTES.series;

export const SETTINGS_ROUTES = {
  root: '/dashboard/settings',
  localization: '/dashboard/settings/localization',
  operationsDefaults: '/dashboard/settings/operations-defaults',
  fx: '/dashboard/settings/fx',
  /** Sağlayıcı ayarının ürettiği veri: günlük kur tablosu. Aynı bölümün ikinci sekmesi. */
  fxRates: '/dashboard/settings/fx/rates',
  email: '/dashboard/settings/email',
  emailTemplates: '/dashboard/settings/email-templates',
  companyProfile: '/dashboard/settings/company-profile',
  companies: '/dashboard/settings/companies',
  documentNumbering: '/dashboard/settings/document-numbering',
  expenseCategories: '/dashboard/settings/expense-categories',
  printTemplates: '/dashboard/settings/print-templates',
  integrations: {
    marketplaces: '/dashboard/settings/integrations/marketplaces',
    /** Shopify OAuth handoff landing page. Must stay byte-for-byte identical to
        ShopifyOAuthEndpoints.FrontendConnectPath — the backend redirects here after the
        token exchange, so a change on one side silently strands the merchant on the other. */
    shopifyConnect: '/dashboard/settings/integrations/marketplaces/shopify/connect',
    efatura: '/dashboard/settings/integrations/efatura',
    efaturaLogs: '/dashboard/settings/integrations/efatura/logs',
    /** @deprecated Ürün eşleştirme {@link PRODUCT_ROUTES.matching} altına taşındı; bu yol yalnız yönlendirme için duruyor. */
    productMatching: '/dashboard/settings/integrations/product-matching',
  },
  security: {
    users: '/dashboard/settings/security/users',
    auditLogs: '/dashboard/settings/security/audit-logs',
    permissions: '/dashboard/settings/security/permissions',
  },
  apps: '/dashboard/settings/apps',
  billing: '/dashboard/settings/billing',
  billingReturn: '/dashboard/settings/billing/return',
} as const;
